/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { color, space, typography } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';

const Wrapper = styled.div`
  ${space}

  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  position: absolute;
  top: 30px;
  left: 0;
  right: 0;
  padding-top: ${themeGet('space.xs')}px;
  z-index: 999;

  & > ul {
    width: 100%;
    max-height: 300px;
    overflow: auto;
    padding: 0;
    margin: 0;
    list-style: none;
    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04),
      0px 10px 20px rgba(0, 0, 0, 0.04);

    border: 1px solid ${themeGet('colors.primary_100')};

    & > li {
      display: flex;
      align-items: center;
      padding: 0 ${themeGet('space.xs')}px;
      min-width: 130px;
      height: 48px;
      border-bottom: 1px solid ${themeGet('colors.primary_100')};
      background: ${themeGet('colors.white')};

      :last-child {
        border-bottom: none;
      }

      :hover {
        background: ${themeGet('colors.primary_100')};
      }
    }
  }
`;

const TextEllipsis = styled.p`
  ${typography}
  ${color}
  ${space}

  height: ${({ line }) => line * 22}px;
  overflow: hidden;
  text-overflow: ellipsis;
  /* stylelint-disable */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  /* stylelint-enable */
  -webkit-line-clamp: ${({ line }) => line};
`;

const Item = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${themeGet('space.xs')}px;
  min-width: 130px;
  height: 48px;
  border-bottom: 1px solid ${themeGet('colors.primary_100')};
  background: ${themeGet('colors.white')};
  cursor: pointer;

  :last-child {
    border-bottom: none;
  }

  :hover {
    background: ${themeGet('colors.primary_100')};
  }
`;

const ExcludeButton = styled.span`
  color: ${themeGet('colors.red_400')};
  font-weight: bold;
  padding: 2px 6px;
  border-radius: 3px;
  cursor: pointer;
  user-select: none;
  
  &:hover {
    background-color: ${themeGet('colors.red_100')};
  }
`;

function ItemComponent({ option, onInclude, onExclude }) {
  const handleIncludeClick = useCallback(() => {
    onInclude(option.label);
  }, [onInclude, option]);

  const handleExcludeClick = useCallback((e) => {
    e.stopPropagation();
    onExclude(option.label);
  }, [onExclude, option]);

  return (
    <Item onClick={handleIncludeClick}>
      <TextEllipsis
        fontSize="display"
        lineHeight="display"
        fontWeight="medium"
        color="grey_400"
        line="2"
      >
        {option.label}
      </TextEllipsis>
      <ExcludeButton onClick={handleExcludeClick}>
        -
      </ExcludeButton>
    </Item>
  );
}

function List({ haveMore, options, isOpen, onClick, onMore, onExclude }) {
  return (
    <Wrapper isOpen={isOpen}>
      <ul>
        {options.map((option) => (
          <ItemComponent 
            key={option.key} 
            option={option} 
            onInclude={onClick} 
            onExclude={onExclude}
          />
        ))}
        {haveMore && <li onClick={onMore}>more...</li>}
      </ul>
    </Wrapper>
  );
}

export default List;
